// extracted by mini-css-extract-plugin
export var header = "Header-module--header--1Qt4T";
export var image = "Header-module--image--3gy7f";